import { IComboBoxOption } from "@fluentui/react";
import { IDictionary } from "@ioip/core/lib/utilities";
import { CForm } from "@ioip/procesox/lib";
import { IFileUploadItem } from "ioip-base/lib/common";
import { IRadicadoEntradaExtended, defaultIRadicadoEntradaExtended } from "../../classes/radicado-entrada-extended";
import { BaseState } from "../../classes/shared/base.state";
import { IMetadatoAsociado, ITramite, IValorMetadato, defaultITramite } from "../../ioip/sdk/base";

export interface ICrearSolicitudComponentState extends BaseState<IRadicadoEntradaExtended> {
    data: {
        tramitesCO: IComboBoxOption[];
        tiposActuacion: IComboBoxOption[];
        tiposDiscapacidad: IComboBoxOption[];
        tiposIdentificacion: IComboBoxOption[];
        tiposSolicitante: IComboBoxOption[];
    }
    Valores: IValorMetadato[];
    metadatos: IMetadatoAsociado[];
    errors: { [ key: string ]: string },
    tramite: ITramite;
    disclaimer: {
        show: boolean;
        title: string;
        text: string;
        isPersonalData?: boolean;
    }
    labelsDenunciante: {
        nombre: string;
        apellido: string;
        tipoIdentificacion: string;
        numeroIdentificacion: string;
        email: string;
    }
    show_ActuaEn_Discapacidad: boolean;
    clasificacionesPQRS: IComboBoxOption[];
    showClasificacionPQRS: boolean;
    NumeroRadicadoSalida: string;
    showDescripcionTramite: boolean;
    descripcionTramite: string;
    procesoxFunction: any;
    procesoxState: { [ key: string ]: any };
    attachments: IFileUploadItem[];
    procesoxEntryPoint: CForm;
    functionHostValidator: (values: IDictionary<any>) => IDictionary<string>;
    palabrasClave: string[];
    keywordsDataSource: IComboBoxOption[];
    showCampoOtro: boolean;
}

export function defaultICrearSolicitudComponentState(): ICrearSolicitudComponentState {
    return {
        model: defaultIRadicadoEntradaExtended(),
        Valores: [],
        metadatos: [],
        errors: {},
        data: {
            tramitesCO: [],
            tiposActuacion: [
                { key: 2, text: 'En nombre propio' },
                { key: 1, text: 'Denunciante' }
            ],
            tiposDiscapacidad: [
                { key: 1, text: 'Si' },
                { key: 2, text: 'No' }
            ],
            tiposIdentificacion: [],
            tiposSolicitante: []
        },
        tramite: defaultITramite(),
        disclaimer: {
            show: false,
            text: '',
            title: '',
            isPersonalData: false
        },
        labelsDenunciante: {
            nombre: 'Nombre denunciante',
            apellido: 'Apellido denunciante',
            tipoIdentificacion: 'Tipo de identificación denunciante',
            numeroIdentificacion: 'Identificación denunciante',
            email: 'Email denunciante'
        },
        show_ActuaEn_Discapacidad: false,
        clasificacionesPQRS: [],
        showClasificacionPQRS: false,
        NumeroRadicadoSalida: '',
        showDescripcionTramite: false,
        descripcionTramite: '',
        procesoxFunction: {},
        procesoxState: {},
        attachments: [],
        procesoxEntryPoint: null,
        functionHostValidator: null,
        palabrasClave: [],
        keywordsDataSource: [],
        showCampoOtro: false
    };
}